var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKiosk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7778 25H10.4444M22.6667 21.625H20.4444M17.1111 12.625H9.55556C8.31111 12.625 7.68889 12.625 7.21333 12.8703C6.79521 13.086 6.45527 13.4302 6.24222 13.8535C6 14.335 6 14.965 6 16.225V18.025C6 19.285 6 19.915 6.24222 20.3954C6.45556 20.8195 6.79444 21.1637 7.21333 21.3797C7.68778 21.625 8.31 21.625 9.55222 21.625H17.1111M17.1111 12.625V21.625M17.1111 12.625V10.6C17.1111 9.34 17.1111 8.71 17.3533 8.2285C17.5664 7.80515 17.9063 7.46096 18.3244 7.24525C18.8 7 19.4222 7 20.6667 7H22.4444C23.6889 7 24.3111 7 24.7856 7.24525C25.2044 7.46125 25.5444 7.80438 25.7578 8.2285C26 8.70887 26 9.33887 26 10.5966V21.4034C26 22.6611 26 23.29 25.7578 23.7704C25.5446 24.1943 25.2043 24.5389 24.7856 24.7547C24.3111 25 23.69 25 22.4478 25H20.6633C19.4211 25 18.7989 25 18.3244 24.7547C17.9062 24.5387 17.5662 24.1941 17.3533 23.7704C17.1256 23.3192 17.1122 22.7365 17.1111 21.625M21.5578 10.375V10.3772H21.5556V10.375H21.5578Z",
    stroke: "#4A5568",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiosk);
export default __webpack_public_path__ + "static/media/kiosk.cbf4f0beedf1c510cf91385546196073.svg";
export { ForwardRef as ReactComponent };